module.exports = __webpack_public_path__ + "202408221624/img/huanhu.d07f4a03.png";